import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("path", { key: '1', d: 'M11.7,1.5c1.9,0.6,1.9,1.5,1.6,2.3s-0.7,1.6-1,2.4c-0.9,2.3-1.9,4.6-2.8,6.9C9.4,13.5,9.3,14,8.7,14v1.1\n            c2.3,0.2,2.8,1.4,3.4,1.8c0.1,0.1,0.3,0.1,0.4,0.1h1.7c0-1.5,0-1.5,1-1.5V23c-1,0-1,0-1-1.5h-1.7c-0.2,0-0.3,0.1-0.5,0.1\n            c-0.5,0.5-2.1,1.9-3.9,1.9c-1.5-0.1-3-0.7-4-1.8c-0.1-0.1-0.3-0.2-0.5-0.2H1.8c0,1.5,0,1.5-1,1.5v-7.4c1,0,1,0,1,1.5h1.8\n            c0.2,0,0.4,0,0.5-0.1c0.9-1,2.1-1.6,3.3-1.8v-1.4c0,0-0.5-0.1-0.3-0.8l0.7-3.9c0.3-1.7,0.6-3.3,1-5.1C9,3.5,9.1,3,9.2,2.5\n            C9.2,1.5,9.7,0.8,11.7,1.5z' }),
], 'TransportFuelDrainSensor');
const TransportFuelDrainSensorIcon = function (props) {
    const colors = {
        pressureOn: '#6577ff',
        pressureOff: '#757575',
        disabled: '#ECEEFF',
    };
    return (React.createElement(SvgIcon, Object.assign({ sx: {
            path: {
                fill: colors[props.color],
            },
            transform: props.color == 'pressureOn' ? 'scale(-1, 1)' : 'scale(1, 1)',
        } }, props)));
};
export default memo(TransportFuelDrainSensorIcon);
